module.exports = __webpack_public_path__ + "fonts/19db35b6-b3e8-400b-ae62-a3d37cc9fa56.cf3ca78.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/19db35b6-b3e8-400b-ae62-a3d37cc9fa56.woff
// module id = 168
// module chunks = 245 246